import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46b5e963&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b5e963')) {
      api.createRecord('46b5e963', component.options)
    } else {
      api.reload('46b5e963', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=46b5e963&", function () {
      api.rerender('46b5e963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/MarketExclusiveLabel/index.vue"
export default component.exports